// Mock news data for demonstration
export const mockNewsData = [
  {
    id: 1,
    title: '2024年第一學期開學通知',
    content: '歡迎各位同學回到學校！第一學期將於2024年1月15日正式開始。請同學們準時到校，並攜帶必要的學習用品。',
    category: '學校通知',
    priority: 'high',
    publishDate: '2024-01-10',
    expiryDate: '2024-01-20',
    author: '教務處',
    isRead: false,
    attachments: []
  },
  {
    id: 2,
    title: '課外活動報名開始',
    content: '本學期課外活動報名現已開始，包括游泳、音樂、美術、體育等課程。請有興趣的同學於1月20日前到教務處報名。',
    category: '課外活動',
    priority: 'medium',
    publishDate: '2024-01-12',
    expiryDate: '2024-01-25',
    author: '課外活動組',
    isRead: false,
    attachments: ['課外活動簡介.pdf']
  },
  {
    id: 3,
    title: '家長會會議通知',
    content: '本學期第一次家長會將於1月25日下午2:00在學校禮堂舉行，請各位家長準時參加。',
    category: '家長通知',
    priority: 'high',
    publishDate: '2024-01-14',
    expiryDate: '2024-01-26',
    author: '家長教師會',
    isRead: false,
    attachments: ['家長會議程.pdf']
  },
  {
    id: 4,
    title: '圖書館開放時間調整',
    content: '由於學期開始，圖書館開放時間調整為週一至週五上午8:00至下午5:00，週六上午9:00至下午3:00。',
    category: '設施服務',
    priority: 'low',
    publishDate: '2024-01-13',
    expiryDate: '2024-02-01',
    author: '圖書館',
    isRead: true,
    attachments: []
  },
  {
    id: 5,
    title: '學費繳交提醒',
    content: '請各位同學注意，第一學期學費繳交截止日期為1月31日，逾期將收取滯納金。',
    category: '財務通知',
    priority: 'high',
    publishDate: '2024-01-15',
    expiryDate: '2024-02-01',
    author: '財務處',
    isRead: false,
    attachments: ['學費繳交指南.pdf']
  },
  {
    id: 6,
    title: '校園安全提醒',
    content: '請同學們注意校園安全，不要在走廊奔跑，上下樓梯要扶扶手，保持校園整潔。',
    category: '安全提醒',
    priority: 'medium',
    publishDate: '2024-01-16',
    expiryDate: '2024-01-30',
    author: '訓導處',
    isRead: true,
    attachments: []
  },
  {
    id: 7,
    title: '環保回收活動',
    content: '學校將於每週五進行環保回收活動，請同學們將可回收物品帶到學校，共同為環保出一份力。',
    category: '環保活動',
    priority: 'low',
    publishDate: '2024-01-17',
    expiryDate: '2024-02-01',
    author: '環保組',
    isRead: false,
    attachments: ['環保回收指南.pdf']
  },
  {
    id: 8,
    title: '考試時間表公佈',
    content: '第一學期期中考試將於3月15日至3月20日舉行，詳細時間表請查看附件。',
    category: '考試通知',
    priority: 'high',
    publishDate: '2024-01-18',
    expiryDate: '2024-03-21',
    author: '教務處',
    isRead: false,
    attachments: ['考試時間表.pdf']
  }
];

// Helper function to get news by category
export const getNewsByCategory = (category) => {
  return mockNewsData.filter(news => news.category === category);
};

// Helper function to get news by priority
export const getNewsByPriority = (priority) => {
  return mockNewsData.filter(news => news.priority === priority);
};

// Helper function to get unread news
export const getUnreadNews = () => {
  return mockNewsData.filter(news => !news.isRead);
};

// Helper function to get news by date range
export const getNewsByDateRange = (startDate, endDate) => {
  return mockNewsData.filter(news => {
    const publishDate = new Date(news.publishDate);
    return publishDate >= new Date(startDate) && publishDate <= new Date(endDate);
  });
};

// Helper function to mark news as read
export const markNewsAsRead = (newsId) => {
  const news = mockNewsData.find(n => n.id === newsId);
  if (news) {
    news.isRead = true;
  }
  return news;
};
